import { FilterOption } from '../../../components/_WMS/FilterComponent'
import { eWorkOrderState } from '../../../enums/eWorkOrderState'

export const filterOptions: FilterOption[] = [
  {
    order: 1,
    key: 'workOrderId',
    label: 'ID Orden de Trabajo',
    type: 'numeric'
  },
  { order: 2, key: 'orderReferenceId', label: 'ID de Pedido', type: 'text' },
  {
    order: 3,
    key: 'pickingRouteId',
    label: 'Ruta de Picking',
    type: 'numericnotnegative'
  },
  {
    order: 4,
    key: 'workOrderStateId',
    label: 'Estado',
    type: 'precreated',
    canBeRepeated: true
  },
  { order: 5, key: 'workOrderTag', label: 'Tag', type: 'textempty' },
  {
    order: 6,
    key: 'courierId',
    label: 'Courier',
    type: 'precreated'
  },
  {
    order: 7,
    key: 'courierServiceId',
    label: 'Servicio de Courier',
    type: 'precreated'
  },
  {
    order: 8,
    key: 'initialDeliveryDate',
    label: 'Fecha Entrega Desde',
    type: 'date'
  },
  {
    order: 9,
    key: 'finalDeliveryDate',
    label: 'Fecha Entrega Hasta',
    type: 'date'
  },
  {
    order: 10,
    key: 'initialCreatedDate',
    label: 'Fecha Creación Desde',
    type: 'date'
  },
  {
    order: 11,
    key: 'finalCreatedDate',
    label: 'Fecha Creación Hasta',
    type: 'date'
  },
  {
    order: 12,
    key: 'sku',
    label: 'SKU',
    type: 'text'
  },
  {
    order: 13,
    key: 'numberUnitsInitial',
    label: 'Cantidad de Unidades Desde',
    type: 'numericnotnegative'
  },
  {
    order: 14,
    key: 'numberUnitsFinal',
    label: 'Cantidad de Unidades Hasta',
    type: 'numericnotnegative'
  },
  {
    order: 15,
    key: 'warehouseId',
    label: 'Almacén',
    type: 'precreated'
  },
  {
    order: 16,
    key: 'typeOrderId',
    label: 'Tipo de Pedido',
    type: 'precreated'
  },
  {
    order: 17,
    key: 'orderOriginId',
    label: 'Origen Marca',
    type: 'precreated',
    canBeRepeated: true
  }
]

export const defaultFilters = [
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.CREATED,
    label: 'Estado',
    displayValue: 'Creada'
  },
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.AVAILABLE_FOR_PICKING,
    label: 'Estado',
    displayValue: 'Disponible para picking'
  },
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.ON_PICKING_ROUTE,
    label: 'Estado',
    displayValue: 'En ruta de picking'
  },
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.ON_MASSIVE_PROCESS,
    label: 'Estado',
    displayValue: 'En proceso masivo'
  },
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.PICKING_FINISHED,
    label: 'Estado',
    displayValue: 'Picking finalizado'
  },
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.ON_VALIDATION,
    label: 'Estado',
    displayValue: 'En validación'
  },
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.VALIDATION_FINISHED,
    label: 'Estado',
    displayValue: 'Validación Finalizada'
  },
  {
    key: 'workOrderStateId',
    value: eWorkOrderState.AVAILABLE_FOR_EXTERNAL_PICKING,
    label: 'Estado',
    displayValue: 'Disponible para picking externo'
  }
]
